import { createFileRoute } from "@tanstack/react-router";

import { ReferralLanding } from "@/components/ReferralLanding";
import { utmSearch } from "@/lib/referral";

/**
 * Link de campanha: `/r/<codigo>/<campanha>`.
 *
 * As UTMs vêm da campanha cadastrada — o link fica curto para falar em voz
 * alta e caber num story.
 */
export const Route = createFileRoute("/r/$code/$campaign")({
  validateSearch: utmSearch,
  head: () => ({ meta: [{ title: "Monte seu uniforme — MonteBox" }] }),
  component: CampaignLink,
});

function CampaignLink() {
  const { code, campaign } = Route.useParams();
  return <ReferralLanding code={code} campaign={campaign} search={Route.useSearch()} />;
}
